import VueCookie from 'vue-cookies'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueCookie)
})
